// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://code.highcharts.com/css/stocktools/gui.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://code.highcharts.com/css/annotations/popup.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}
.barz {
  .highcharts-stocktools-wrapper {
    display: none;
  }
}
#highcharts-container {
  width: 100%;
}

.highcharts-indicators {
  display: none;
}
.strikethrough {
  text-decoration: line-through;
}

/* SubMenu Styles */
.menu-paper {
  background-color: #2e2e32;
}

.menu-list {
  margin-top: 8px;
  min-width: 170px;
  max-width: 250px;
  border-radius: 8px;
}

.menu-item {
  display: flex;
  gap: 8px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  align-items: center;
  color: white;
}

.menu-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.menu-item-icon {
  min-width: 24px;
  color: inherit;
}

.text-white {
  color: white;
}

.text-red {
  color: red;
}

.tradegpt-widget-recent-prompts__section__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  cursor: pointer;
}

.tradegpt-widget-recent-prompts__section__item__content {
  flex-grow: 1;
}

.tgpt-sidebar-active {
  background-color: #f0f0f0; /* Adjust as needed */
}

/* Add other necessary styles */

/* Assuming \`gizmo-shadow-stroke\` is a custom class */
.gizmo-shadow-stroke {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
}

.flex {
  display: flex;
}

.h-6 {
  height: 1.5rem;
  /* 24px */
}

.w-6 {
  width: 1.5rem;
  /* 24px */
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.overflow-hidden {
  overflow: hidden;
}

.rounded-full {
  border-radius: 9999px;
}

.w-full {
  width: 100%;
}

.text-token-text-primary {
  color: var(--token-text-primary);
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.justify-center {
  justify-content: center;
}

.text-base {
  font-size: 1rem;
}

.md\\:gap-6 {
  gap: 1.5rem;
  /* 24px */
}

.m-auto {
  margin: auto;
}

.flex-1 {
  flex: 1;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.gap-3 {
  gap: 0.75rem;
  /* 12px */
}

.md\\:px-5 {
  padding-left: 1.25rem;
  /* 20px */
  padding-right: 1.25rem;
  /* 20px */
}

.lg\\:px-1 {
  padding-left: 0.25rem;
  /* 4px */
  padding-right: 0.25rem;
  /* 4px */
}

.xl\\:px-5 {
  padding-left: 1.25rem;
  /* 20px */
  padding-right: 1.25rem;
  /* 20px */
}

.md\\:max-w-3xl {
  max-width: 48rem;
  /* 768px */
}

.lg\\:max-w-\\[40rem\\] {
  max-width: 40rem;
  /* 640px */
}

.xl\\:max-w-\\[48rem\\] {
  max-width: 48rem;
  /* 768px */
}

.flex-shrink-0 {
  flex-shrink: 0;
}

.relative {
  position: relative;
}

.items-end {
  align-items: flex-end;
}

.pt-0\\.5 {
  padding-top: 0.125rem;
  /* 2px */
}

.w-6 {
  width: 1.5rem;
  /* 24px */
}

.h-6 {
  height: 1.5rem;
  /* 24px */
}

.rounded-sm {
  border-radius: 0.125rem;
  /* 2px */
}

.font-semibold {
  font-weight: 600;
}

.select-none {
  user-select: none;
}

.flex-col {
  flex-direction: column;
}

.gap-1 {
  gap: 0.25rem;
  /* 4px */
}

.md\\:gap-3 {
  gap: 0.75rem;
  /* 12px */
}

.flex-grow {
  flex-grow: 1;
}

.max-w-full {
  max-width: 100%;
}

.min-h-\\[20px\\] {
  min-height: 20px;
}

.overflow-y-hidden {
  overflow-y: hidden;
}

.break-words {
  word-break: break-word;
}

.overflow-x-auto {
  overflow-x: auto;
}

.space-x-2 {
  margin-left: -0.5rem;

  /* -8px */
  &> :not([hidden])~ :not([hidden]) {
    margin-left: 0.5rem;
    /* 8px */
  }
}

.mt-1 {
  margin-top: 0.25rem;
  /* 4px */
}

.text-sm {
  font-size: 0.875rem;
  /* 14px */
}

.text-token-text-secondary {
  color: var(--token-text-secondary);
}

.tradegpt-widget {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  overflow: hidden;
}
.p-16 {
  padding: 16px;
  padding-bottom: 0px;
}
.tradegpt-widget__sidebar {
  display: flex;
  width: 260px;
  height: auto;
  padding: 16px 0px;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  flex-shrink: 0;
  background: #fff;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

.tradegpt-widget__sidebar__header {
  padding: 0px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  width: 100%;
}

.tradegpt-widget__sidebar__header__title {
  color: rgba(0, 0, 0, 0.87);
  font-family: inherit;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 160%;
  letter-spacing: -0.011px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}

.tradegpt-widget__sidebar__header__splitter {
  width: 27px;
  height: 1px;
  background: #FFFFFF;
}

.tradegpt-widget__sidebar__content {
  width: 100%;
  height: 100%;
}

.tradegpt-widget__sidebar__content__title {
  color: #FFF;
  font-family: inherit;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.06px;
  margin-bottom: 10px;
}

.tradegpt-widget__sidebar__content__prompts {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  height: calc(100% - 31px);
  max-height: 250px;
  overflow: auto;
}

.tradegpt-widget__sidebar__content__prompts::-webkit-scrollbar {
  display: none;
}

.tradegpt-widget__sidebar__content__prompt {
  border-radius: 10px;
  border: 1px solid #CCC;
  padding: 10px 16px;
  color: #CCC;
  font-family: inherit;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.01px;
  width: 100%;
  cursor: pointer;
}

.tradegpt-widget__content {
  width: 100%;
  padding: 16px 0px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 20px;

  &.full-screen-view {
    width: calc(100% - 255px);
    padding-left: 24px;
    padding-right: 24px;
  }
}

.tradegpt-widget__header {
  width: 100%;
  display: flex;
  padding: 0px 16px;
  align-items: center;
  justify-content: space-between;
}

.tradegpt-widget__header__title {
  text-overflow: ellipsis;
  overflow: hidden;
  font-family: inherit;
  color: rgba(0, 0, 0, 0.87);
  text-overflow: ellipsis;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 143%;
  letter-spacing: 0.17px;
  display: -webkit-box;
}

.tradegpt-widget__content__messages {
  height: calc(100% - 142px);
  min-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  overflow: auto;
  padding: 0px 16px;
}

.tradegpt-widget__content__messages> :first-child {
  margin-top: auto;
  flex-direction: column;
}

.tradegpt-widget__content__messages::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
.tradegpt-widget__content__messages::-webkit-scrollbar-track {
  background: #F8FAFC;
}

.tradegpt-dark-widget .tradegpt-widget__content__messages::-webkit-scrollbar-track {
  background: #000;
}

/* Handle */
.tradegpt-widget__content__messages::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
.tradegpt-widget__content__messages::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.tradegpt-widget__content__get_started__items::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
.tradegpt-widget__content__get_started__items::-webkit-scrollbar-track {
  background: #F8FAFC;
}

.tradegpt-dark-widget .tradegpt-widget__content__get_started__items::-webkit-scrollbar-track {
  background: #000;
}

/* Handle */
.tradegpt-widget__content__get_started__items::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
.tradegpt-widget__content__get_started__items::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.flex-end {
  align-items: flex-end;
}

.flex-reverse {
  flex-direction: row-reverse;
}

.tradegpt-widget__content-start-message {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
  font-size: 20px;
  font-weight: 500;
  line-height: 160%;
  letter-spacing: 0.15px;
  position: relative;
  background-size: 200% auto;
  background-clip: text;
  -webkit-background-clip: text; /* For Safari */
  color: transparent;
  animation: shine 6s linear infinite;
}

.tradegpt-widget__content-start-message.full-screen-view {
  font-weight: bold;
}

@keyframes shine {
  0% {
    background-position: 200% center;
  }
  100% {
    background-position: -200% center;
  }
}

/* Light Mode */
.tradegpt-widget__content-start-message {
  color: rgba(0, 0, 0, 0.60);
  background-image: linear-gradient(
    to right,
    rgba(2, 2, 2, 0.432) 0%,
    rgba(2, 2, 2, 0.432) 45%,
    rgba(255, 255, 255, 0.9) 50%,
    rgba(2, 2, 2, 0.432) 55%,
    rgba(2, 2, 2, 0.432) 100%
  );
}

.max-w-3 {
  max-width: 300px;
}
.chat-bubble{
  border-radius: 12px;
  background: var(--TA-background-main, #F8FAFC);
  p{
    padding: 8px;
    padding-right: 10px;
  }
}
.tradegpt-widget__content__message {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 6px;
  width: 100%;
}

.tradegpt-widget__content__message__avatar img {
  width: 22px;
  height: 22px;
  border-radius: 50%;
}

.tradegpt-widget-username {
  color: #007BFF;
  font-family: inherit;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.06px;
}

.tradegpt-widget-username.tradegpt-widget-bot-name {
  color: #000;
}

.tradegpt-widget__content__message__text {
  color: #A6A6A6;
  font-family: inherit;
  padding-bottom: 12px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.06px;
  width: 100%;
}

.custom-tradegpt-widget-message-content {
  width: calc(100% - 24px - 0.75rem) !important;
}

.tradegpt-widget__content__message__action_icons {
  margin-top: 4px;
}

.tradegpt-widget__content__message__action_icons svg {
  cursor: pointer;
}

.tradegpt-widget__content__footer__input__send-icon {
  position: absolute !important;
  border-radius: 8px !important;
  background: #1C1C1E !important;
  padding: 6px !important;
  cursor: pointer !important;
  right: 16px !important;
  bottom: 16px !important;
  width: 36px !important;
  height: 36px !important;
  display: flex !important;
  align-items: start;
  justify-content: flex-start;
}

.tradegpt-widget__content__footer__input__send-icon:disabled {
  background-color: rgb(166, 166, 166) !important;
}

.tradegpt-widget__content__footer {
  padding: 0px 16px;
  width: 100%;
}

.tradegpt-widget__content__footer__input {
  position: relative;
  width: 100%;
  border-radius: 6px;
  background: #F5F5F5;
  padding: 8px 8px 8px 12px;
  height: 102px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: start;
}

textarea.tradegpt-widget-query-input {
  color: #000;
  font-family: inherit;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  background: transparent;
  border: none;
  outline: none;
  resize: none;
  /* Prevents manual resizing */
  width: calc(100% - 50px);
  overflow: hidden;
  /* Hide the scrollbar */
}


.tradegpt-widget__content__footer__hint {
  color: #A3A3A3;
  text-align: center;
  font-family: inherit;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  padding: 8px;
}

.tradegpt-widget__content__footer__dragger {
  border-radius: 100px;
  background: #E4E5E8;
  width: 134px;
  margin: 0 auto;
  height: 5px;
}

.tradegpt-widget__content__get_started {
  margin-top: 10px;
  width: 100%;
}

.tradegpt-widget__content__get_started__title {
  color: #007BFF;
  font-family: inherit;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.052px;
  margin-bottom: 4px;
}

.tradegpt-widget__content__get_started__items {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
  overflow-x: auto;
  padding-bottom: 10px;
}

.tradegpt-widget__content__get_started__item {
  border-radius: 16px;
  border: 1px solid #E4E5E8;
  padding: 10px 16px;
  width: calc((100% - 10px) / 1.5);
  cursor: pointer;
}
.tradegpt-widget__content__get_started__item:hover{
  background-color: #ededed;
}

.tradegpt-widget__content__get_started__items.full-screen-view .tradegpt-widget__content__get_started__item {
  width: auto;
}

.tradegpt-widget__content__get_started__items-vertical {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  flex-direction: column;
  padding-right: 10px;

  .tradegpt-widget__content__get_started__item {
    width: 100%;
  }
}

.tradegpt-widget__content__get_started__item__title {
  color: #1C1C1E;
  font-family: inherit;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.01px;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  overflow: hidden;
}

.tradegpt-widget__content__get_started__item__description {
  overflow: hidden;
  color: #A3A3A3;
  text-overflow: ellipsis;
  font-family: inherit;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.01px;
  text-wrap: nowrap;
}

.tradegpt-widget__content__message__text p,
.tradegpt-widget__content__message__text ul {
  margin: 0;
}

.tradegpt-widget-message-action {
  background: transparent;
  border: none;
}

.tradegpt-widget-message-action.invisible-button {
  display: none;
}

.tradegpt-widget-message-action svg {
  width: 18px;
  height: 18px;
  fill: #000;
}

.tradegpt-widget-text-right {
  text-align: right !important;
}

.tradegpt-widget .MuiCircularProgress-svg {
  color: inherit !important;
  fill: inherit !important;
}

.tradegpt-widget-recent-prompts {
  width: 100%;
  height: calc(100% - 36px - 150px - 40px);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.height-95 {
  height: 95% !important;
}

.tradegpt-widget-recent-prompts__search {
  width: 100%;
  position: relative;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.42);
  display: flex;
  padding: 12px;
  align-items: center;
  align-self: stretch;
  background: rgba(0, 0, 0, 0.06);
}

.tradegpt-widget-recent-prompts__search_input {
  color: rgba(0, 0, 0, 0.60);
  font-family: inherit;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
  width: 100%;
  border: none;
  background: transparent;
  outline: none;
}

.tradegpt-widget-recent-prompts__sections {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  overflow: auto;
  padding: 0px 16px;
}


.tradegpt-widget-recent-prompts__section {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.tradegpt-widget-recent-prompts__section__title {
  color: rgba(0, 0, 0, 0.60);
  font-family: inherit;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 266%;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 0 8px;
}

.tradegpt-widget-recent-prompts__section__item {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 4px 8px;
  cursor: pointer;
  border-radius: 8px;
  max-height: 38px;
  svg {
    cursor: pointer;
    flex: 0 0 auto;
  }

  &:hover {
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.04);
  }
}

.tradegpt-widget-recent-prompts__section__item__title {
  color: rgba(0, 0, 0, 0.87);
  text-overflow: ellipsis;
  font-family: inherit;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 171%;
  letter-spacing: 0.17px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.sidebar-carrot {
  position: absolute;
  z-index: 40;
  display: block;
  left: 0;
  top: 50%;
  opacity: .4;
  transform: translateX(260px) translateY(-50%) rotate(0deg) translateZ(0);
  cursor: pointer;
}

.tgpt-sidebar-active {
  background-color: #e5e5e5;
}

.sidebar-carrot-inner {
  display: flex;
  height: 88px;
  width: 2rem;
  align-items: center;
  justify-content: center;
}

.sidebar-carrot-inner-content {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 1.5rem;
  height: 1.5rem;
}

.carrot-translator {
  height: .75rem;
  width: .25rem;
  border-radius: 99999px;
  background-color: #000;
}

.translator-a,
.translator-b {
  transition: transform .45s ease;
}

.sidebar-carrot .translator-a {
  transform: translateY(.15rem) rotate(0deg) translateZ(0);
}

.sidebar-carrot .translator-b {
  transform: translateY(-.15rem) rotate(0deg) translateZ(0);
}

.sidebar-carrot:hover .translator-a {
  transform: translateY(.15rem) rotate(15deg) translateZ(0);
}

.sidebar-carrot:hover .translator-b {
  transform: translateY(-.15rem) rotate(-15deg) translateZ(0);
}

.tradegpt-widget__sidebar_closed {
  margin-left: -250px;
}

.sidebar-carrot.closed:hover .translator-a {
  transform: translateY(.15rem) rotate(-15deg) translateZ(0);
}

.sidebar-carrot.closed:hover .translator-b {
  transform: translateY(-.15rem) rotate(15deg) translateZ(0);
}

.display-hidden {
  display: none;
}

.display-flex {
  display: flex;
}

.tradegpt-widget-full-width {
  width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./lib/assets/index.css"],"names":[],"mappings":"AAGA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;AAClD;;AAEA,+BAA+B;;AAE/B,qDAAqD;AACrD;EACE,uEAAuE;AACzE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;;EAEpB,SAAS;EACT;IACE,mBAAmB;IACnB,QAAQ;EACV;AACF;;AAEA;EACE,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,SAAS;;EAET;IACE,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,6BAA6B,EAAE,eAAe;EAC9C,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;AACF;;AAEA,eAAe;AACf;EACE,0BAA0B;EAC1B;;;;;;;GAOC;AACH;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C;IACE,YAAY;IACZ,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;AACzB;;;AAGA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,sBAAsB;EACtB,mBAAmB;;EAEnB;IACE,WAAW;EACb;AACF;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,+BAA+B;EACjC;AACF;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,OAAO;EACP,QAAQ;EACR,WAAW;EACX,wEAAwE;EACxE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["@import 'https://code.highcharts.com/css/stocktools/gui.css';\r\n@import 'https://code.highcharts.com/css/annotations/popup.css';\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n.barz {\r\n  .highcharts-stocktools-wrapper {\r\n    display: none;\r\n  }\r\n}\r\n#highcharts-container {\r\n  width: 100%;\r\n}\r\n\r\n.highcharts-indicators {\r\n  display: none;\r\n}\r\n.strikethrough {\r\n  text-decoration: line-through;\r\n}\r\n\r\n/* SubMenu Styles */\r\n.menu-paper {\r\n  background-color: #2e2e32;\r\n}\r\n\r\n.menu-list {\r\n  margin-top: 8px;\r\n  min-width: 170px;\r\n  max-width: 250px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.menu-item {\r\n  display: flex;\r\n  gap: 8px;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  align-items: center;\r\n  color: white;\r\n}\r\n\r\n.menu-item:hover {\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.menu-item-icon {\r\n  min-width: 24px;\r\n  color: inherit;\r\n}\r\n\r\n.text-white {\r\n  color: white;\r\n}\r\n\r\n.text-red {\r\n  color: red;\r\n}\r\n\r\n.tradegpt-widget-recent-prompts__section__item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.tradegpt-widget-recent-prompts__section__item__content {\r\n  flex-grow: 1;\r\n}\r\n\r\n.tgpt-sidebar-active {\r\n  background-color: #f0f0f0; /* Adjust as needed */\r\n}\r\n\r\n/* Add other necessary styles */\r\n\r\n/* Assuming `gizmo-shadow-stroke` is a custom class */\r\n.gizmo-shadow-stroke {\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.flex {\r\n  display: flex;\r\n}\r\n\r\n.h-6 {\r\n  height: 1.5rem;\r\n  /* 24px */\r\n}\r\n\r\n.w-6 {\r\n  width: 1.5rem;\r\n  /* 24px */\r\n}\r\n\r\n.items-center {\r\n  align-items: center;\r\n}\r\n\r\n.justify-center {\r\n  justify-content: center;\r\n}\r\n\r\n.overflow-hidden {\r\n  overflow: hidden;\r\n}\r\n\r\n.rounded-full {\r\n  border-radius: 9999px;\r\n}\r\n\r\n.w-full {\r\n  width: 100%;\r\n}\r\n\r\n.text-token-text-primary {\r\n  color: var(--token-text-primary);\r\n}\r\n\r\n.px-4 {\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n}\r\n\r\n.py-2 {\r\n  padding-top: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n}\r\n\r\n.justify-center {\r\n  justify-content: center;\r\n}\r\n\r\n.text-base {\r\n  font-size: 1rem;\r\n}\r\n\r\n.md\\:gap-6 {\r\n  gap: 1.5rem;\r\n  /* 24px */\r\n}\r\n\r\n.m-auto {\r\n  margin: auto;\r\n}\r\n\r\n.flex-1 {\r\n  flex: 1;\r\n}\r\n\r\n.mx-auto {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.gap-3 {\r\n  gap: 0.75rem;\r\n  /* 12px */\r\n}\r\n\r\n.md\\:px-5 {\r\n  padding-left: 1.25rem;\r\n  /* 20px */\r\n  padding-right: 1.25rem;\r\n  /* 20px */\r\n}\r\n\r\n.lg\\:px-1 {\r\n  padding-left: 0.25rem;\r\n  /* 4px */\r\n  padding-right: 0.25rem;\r\n  /* 4px */\r\n}\r\n\r\n.xl\\:px-5 {\r\n  padding-left: 1.25rem;\r\n  /* 20px */\r\n  padding-right: 1.25rem;\r\n  /* 20px */\r\n}\r\n\r\n.md\\:max-w-3xl {\r\n  max-width: 48rem;\r\n  /* 768px */\r\n}\r\n\r\n.lg\\:max-w-\\[40rem\\] {\r\n  max-width: 40rem;\r\n  /* 640px */\r\n}\r\n\r\n.xl\\:max-w-\\[48rem\\] {\r\n  max-width: 48rem;\r\n  /* 768px */\r\n}\r\n\r\n.flex-shrink-0 {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.relative {\r\n  position: relative;\r\n}\r\n\r\n.items-end {\r\n  align-items: flex-end;\r\n}\r\n\r\n.pt-0\\.5 {\r\n  padding-top: 0.125rem;\r\n  /* 2px */\r\n}\r\n\r\n.w-6 {\r\n  width: 1.5rem;\r\n  /* 24px */\r\n}\r\n\r\n.h-6 {\r\n  height: 1.5rem;\r\n  /* 24px */\r\n}\r\n\r\n.rounded-sm {\r\n  border-radius: 0.125rem;\r\n  /* 2px */\r\n}\r\n\r\n.font-semibold {\r\n  font-weight: 600;\r\n}\r\n\r\n.select-none {\r\n  user-select: none;\r\n}\r\n\r\n.flex-col {\r\n  flex-direction: column;\r\n}\r\n\r\n.gap-1 {\r\n  gap: 0.25rem;\r\n  /* 4px */\r\n}\r\n\r\n.md\\:gap-3 {\r\n  gap: 0.75rem;\r\n  /* 12px */\r\n}\r\n\r\n.flex-grow {\r\n  flex-grow: 1;\r\n}\r\n\r\n.max-w-full {\r\n  max-width: 100%;\r\n}\r\n\r\n.min-h-\\[20px\\] {\r\n  min-height: 20px;\r\n}\r\n\r\n.overflow-y-hidden {\r\n  overflow-y: hidden;\r\n}\r\n\r\n.break-words {\r\n  word-break: break-word;\r\n}\r\n\r\n.overflow-x-auto {\r\n  overflow-x: auto;\r\n}\r\n\r\n.space-x-2 {\r\n  margin-left: -0.5rem;\r\n\r\n  /* -8px */\r\n  &> :not([hidden])~ :not([hidden]) {\r\n    margin-left: 0.5rem;\r\n    /* 8px */\r\n  }\r\n}\r\n\r\n.mt-1 {\r\n  margin-top: 0.25rem;\r\n  /* 4px */\r\n}\r\n\r\n.text-sm {\r\n  font-size: 0.875rem;\r\n  /* 14px */\r\n}\r\n\r\n.text-token-text-secondary {\r\n  color: var(--token-text-secondary);\r\n}\r\n\r\n.tradegpt-widget {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: stretch;\r\n  justify-content: flex-start;\r\n  overflow: hidden;\r\n}\r\n.p-16 {\r\n  padding: 16px;\r\n  padding-bottom: 0px;\r\n}\r\n.tradegpt-widget__sidebar {\r\n  display: flex;\r\n  width: 260px;\r\n  height: auto;\r\n  padding: 16px 0px;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 15px;\r\n  flex-shrink: 0;\r\n  background: #fff;\r\n  border-right: 1px solid rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.tradegpt-widget__sidebar__header {\r\n  padding: 0px 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 4px;\r\n  width: 100%;\r\n}\r\n\r\n.tradegpt-widget__sidebar__header__title {\r\n  color: rgba(0, 0, 0, 0.87);\r\n  font-family: inherit;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 160%;\r\n  letter-spacing: -0.011px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  gap: 8px;\r\n}\r\n\r\n.tradegpt-widget__sidebar__header__splitter {\r\n  width: 27px;\r\n  height: 1px;\r\n  background: #FFFFFF;\r\n}\r\n\r\n.tradegpt-widget__sidebar__content {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.tradegpt-widget__sidebar__content__title {\r\n  color: #FFF;\r\n  font-family: inherit;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%;\r\n  letter-spacing: -0.06px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.tradegpt-widget__sidebar__content__prompts {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n  gap: 10px;\r\n  height: calc(100% - 31px);\r\n  max-height: 250px;\r\n  overflow: auto;\r\n}\r\n\r\n.tradegpt-widget__sidebar__content__prompts::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.tradegpt-widget__sidebar__content__prompt {\r\n  border-radius: 10px;\r\n  border: 1px solid #CCC;\r\n  padding: 10px 16px;\r\n  color: #CCC;\r\n  font-family: inherit;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 18px;\r\n  letter-spacing: -0.01px;\r\n  width: 100%;\r\n  cursor: pointer;\r\n}\r\n\r\n.tradegpt-widget__content {\r\n  width: 100%;\r\n  padding: 16px 0px;\r\n  background: #fff;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: flex-end;\r\n  gap: 20px;\r\n\r\n  &.full-screen-view {\r\n    width: calc(100% - 255px);\r\n    padding-left: 24px;\r\n    padding-right: 24px;\r\n  }\r\n}\r\n\r\n.tradegpt-widget__header {\r\n  width: 100%;\r\n  display: flex;\r\n  padding: 0px 16px;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.tradegpt-widget__header__title {\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  font-family: inherit;\r\n  color: rgba(0, 0, 0, 0.87);\r\n  text-overflow: ellipsis;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 143%;\r\n  letter-spacing: 0.17px;\r\n  display: -webkit-box;\r\n}\r\n\r\n.tradegpt-widget__content__messages {\r\n  height: calc(100% - 142px);\r\n  min-width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n  width: 100%;\r\n  overflow: auto;\r\n  padding: 0px 16px;\r\n}\r\n\r\n.tradegpt-widget__content__messages> :first-child {\r\n  margin-top: auto;\r\n  flex-direction: column;\r\n}\r\n\r\n.tradegpt-widget__content__messages::-webkit-scrollbar {\r\n  width: 5px;\r\n  height: 5px;\r\n}\r\n\r\n/* Track */\r\n.tradegpt-widget__content__messages::-webkit-scrollbar-track {\r\n  background: #F8FAFC;\r\n}\r\n\r\n.tradegpt-dark-widget .tradegpt-widget__content__messages::-webkit-scrollbar-track {\r\n  background: #000;\r\n}\r\n\r\n/* Handle */\r\n.tradegpt-widget__content__messages::-webkit-scrollbar-thumb {\r\n  background: #888;\r\n}\r\n\r\n/* Handle on hover */\r\n.tradegpt-widget__content__messages::-webkit-scrollbar-thumb:hover {\r\n  background: #555;\r\n}\r\n\r\n.tradegpt-widget__content__get_started__items::-webkit-scrollbar {\r\n  width: 5px;\r\n  height: 5px;\r\n}\r\n\r\n/* Track */\r\n.tradegpt-widget__content__get_started__items::-webkit-scrollbar-track {\r\n  background: #F8FAFC;\r\n}\r\n\r\n.tradegpt-dark-widget .tradegpt-widget__content__get_started__items::-webkit-scrollbar-track {\r\n  background: #000;\r\n}\r\n\r\n/* Handle */\r\n.tradegpt-widget__content__get_started__items::-webkit-scrollbar-thumb {\r\n  background: #888;\r\n}\r\n\r\n/* Handle on hover */\r\n.tradegpt-widget__content__get_started__items::-webkit-scrollbar-thumb:hover {\r\n  background: #555;\r\n}\r\n\r\n.flex-end {\r\n  align-items: flex-end;\r\n}\r\n\r\n.flex-reverse {\r\n  flex-direction: row-reverse;\r\n}\r\n\r\n.tradegpt-widget__content-start-message {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-family: inherit;\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n  line-height: 160%;\r\n  letter-spacing: 0.15px;\r\n  position: relative;\r\n  background-size: 200% auto;\r\n  background-clip: text;\r\n  -webkit-background-clip: text; /* For Safari */\r\n  color: transparent;\r\n  animation: shine 6s linear infinite;\r\n}\r\n\r\n.tradegpt-widget__content-start-message.full-screen-view {\r\n  font-weight: bold;\r\n}\r\n\r\n@keyframes shine {\r\n  0% {\r\n    background-position: 200% center;\r\n  }\r\n  100% {\r\n    background-position: -200% center;\r\n  }\r\n}\r\n\r\n/* Light Mode */\r\n.tradegpt-widget__content-start-message {\r\n  color: rgba(0, 0, 0, 0.60);\r\n  background-image: linear-gradient(\r\n    to right,\r\n    rgba(2, 2, 2, 0.432) 0%,\r\n    rgba(2, 2, 2, 0.432) 45%,\r\n    rgba(255, 255, 255, 0.9) 50%,\r\n    rgba(2, 2, 2, 0.432) 55%,\r\n    rgba(2, 2, 2, 0.432) 100%\r\n  );\r\n}\r\n\r\n.max-w-3 {\r\n  max-width: 300px;\r\n}\r\n.chat-bubble{\r\n  border-radius: 12px;\r\n  background: var(--TA-background-main, #F8FAFC);\r\n  p{\r\n    padding: 8px;\r\n    padding-right: 10px;\r\n  }\r\n}\r\n.tradegpt-widget__content__message {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 6px;\r\n  width: 100%;\r\n}\r\n\r\n.tradegpt-widget__content__message__avatar img {\r\n  width: 22px;\r\n  height: 22px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.tradegpt-widget-username {\r\n  color: #007BFF;\r\n  font-family: inherit;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 22px;\r\n  letter-spacing: -0.06px;\r\n}\r\n\r\n.tradegpt-widget-username.tradegpt-widget-bot-name {\r\n  color: #000;\r\n}\r\n\r\n.tradegpt-widget__content__message__text {\r\n  color: #A6A6A6;\r\n  font-family: inherit;\r\n  padding-bottom: 12px;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 150%;\r\n  letter-spacing: -0.06px;\r\n  width: 100%;\r\n}\r\n\r\n.custom-tradegpt-widget-message-content {\r\n  width: calc(100% - 24px - 0.75rem) !important;\r\n}\r\n\r\n.tradegpt-widget__content__message__action_icons {\r\n  margin-top: 4px;\r\n}\r\n\r\n.tradegpt-widget__content__message__action_icons svg {\r\n  cursor: pointer;\r\n}\r\n\r\n.tradegpt-widget__content__footer__input__send-icon {\r\n  position: absolute !important;\r\n  border-radius: 8px !important;\r\n  background: #1C1C1E !important;\r\n  padding: 6px !important;\r\n  cursor: pointer !important;\r\n  right: 16px !important;\r\n  bottom: 16px !important;\r\n  width: 36px !important;\r\n  height: 36px !important;\r\n  display: flex !important;\r\n  align-items: start;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.tradegpt-widget__content__footer__input__send-icon:disabled {\r\n  background-color: rgb(166, 166, 166) !important;\r\n}\r\n\r\n.tradegpt-widget__content__footer {\r\n  padding: 0px 16px;\r\n  width: 100%;\r\n}\r\n\r\n.tradegpt-widget__content__footer__input {\r\n  position: relative;\r\n  width: 100%;\r\n  border-radius: 6px;\r\n  background: #F5F5F5;\r\n  padding: 8px 8px 8px 12px;\r\n  height: 102px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: start;\r\n}\r\n\r\ntextarea.tradegpt-widget-query-input {\r\n  color: #000;\r\n  font-family: inherit;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n  background: transparent;\r\n  border: none;\r\n  outline: none;\r\n  resize: none;\r\n  /* Prevents manual resizing */\r\n  width: calc(100% - 50px);\r\n  overflow: hidden;\r\n  /* Hide the scrollbar */\r\n}\r\n\r\n\r\n.tradegpt-widget__content__footer__hint {\r\n  color: #A3A3A3;\r\n  text-align: center;\r\n  font-family: inherit;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 16px;\r\n  padding: 8px;\r\n}\r\n\r\n.tradegpt-widget__content__footer__dragger {\r\n  border-radius: 100px;\r\n  background: #E4E5E8;\r\n  width: 134px;\r\n  margin: 0 auto;\r\n  height: 5px;\r\n}\r\n\r\n.tradegpt-widget__content__get_started {\r\n  margin-top: 10px;\r\n  width: 100%;\r\n}\r\n\r\n.tradegpt-widget__content__get_started__title {\r\n  color: #007BFF;\r\n  font-family: inherit;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%;\r\n  letter-spacing: -0.052px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.tradegpt-widget__content__get_started__items {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  gap: 10px;\r\n  width: 100%;\r\n  overflow-x: auto;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.tradegpt-widget__content__get_started__item {\r\n  border-radius: 16px;\r\n  border: 1px solid #E4E5E8;\r\n  padding: 10px 16px;\r\n  width: calc((100% - 10px) / 1.5);\r\n  cursor: pointer;\r\n}\r\n.tradegpt-widget__content__get_started__item:hover{\r\n  background-color: #ededed;\r\n}\r\n\r\n.tradegpt-widget__content__get_started__items.full-screen-view .tradegpt-widget__content__get_started__item {\r\n  width: auto;\r\n}\r\n\r\n.tradegpt-widget__content__get_started__items-vertical {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  gap: 10px;\r\n  flex-direction: column;\r\n  padding-right: 10px;\r\n\r\n  .tradegpt-widget__content__get_started__item {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.tradegpt-widget__content__get_started__item__title {\r\n  color: #1C1C1E;\r\n  font-family: inherit;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 18px;\r\n  letter-spacing: -0.01px;\r\n  text-overflow: ellipsis;\r\n  text-wrap: nowrap;\r\n  overflow: hidden;\r\n}\r\n\r\n.tradegpt-widget__content__get_started__item__description {\r\n  overflow: hidden;\r\n  color: #A3A3A3;\r\n  text-overflow: ellipsis;\r\n  font-family: inherit;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 18px;\r\n  letter-spacing: -0.01px;\r\n  text-wrap: nowrap;\r\n}\r\n\r\n.tradegpt-widget__content__message__text p,\r\n.tradegpt-widget__content__message__text ul {\r\n  margin: 0;\r\n}\r\n\r\n.tradegpt-widget-message-action {\r\n  background: transparent;\r\n  border: none;\r\n}\r\n\r\n.tradegpt-widget-message-action.invisible-button {\r\n  display: none;\r\n}\r\n\r\n.tradegpt-widget-message-action svg {\r\n  width: 18px;\r\n  height: 18px;\r\n  fill: #000;\r\n}\r\n\r\n.tradegpt-widget-text-right {\r\n  text-align: right !important;\r\n}\r\n\r\n.tradegpt-widget .MuiCircularProgress-svg {\r\n  color: inherit !important;\r\n  fill: inherit !important;\r\n}\r\n\r\n.tradegpt-widget-recent-prompts {\r\n  width: 100%;\r\n  height: calc(100% - 36px - 150px - 40px);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.height-95 {\r\n  height: 95% !important;\r\n}\r\n\r\n.tradegpt-widget-recent-prompts__search {\r\n  width: 100%;\r\n  position: relative;\r\n  border-radius: 4px;\r\n  border: 1px solid rgba(0, 0, 0, 0.42);\r\n  display: flex;\r\n  padding: 12px;\r\n  align-items: center;\r\n  align-self: stretch;\r\n  background: rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.tradegpt-widget-recent-prompts__search_input {\r\n  color: rgba(0, 0, 0, 0.60);\r\n  font-family: inherit;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 24px;\r\n  letter-spacing: 0.15px;\r\n  width: 100%;\r\n  border: none;\r\n  background: transparent;\r\n  outline: none;\r\n}\r\n\r\n.tradegpt-widget-recent-prompts__sections {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  height: 100%;\r\n  overflow: auto;\r\n  padding: 0px 16px;\r\n}\r\n\r\n\r\n.tradegpt-widget-recent-prompts__section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n}\r\n\r\n.tradegpt-widget-recent-prompts__section__title {\r\n  color: rgba(0, 0, 0, 0.60);\r\n  font-family: inherit;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 266%;\r\n  letter-spacing: 1px;\r\n  text-transform: uppercase;\r\n  padding: 0 8px;\r\n}\r\n\r\n.tradegpt-widget-recent-prompts__section__item {\r\n  display: flex;\r\n  width: 100%;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  padding: 4px 8px;\r\n  cursor: pointer;\r\n  border-radius: 8px;\r\n  max-height: 38px;\r\n  svg {\r\n    cursor: pointer;\r\n    flex: 0 0 auto;\r\n  }\r\n\r\n  &:hover {\r\n    border-radius: 8px;\r\n    background: rgba(0, 0, 0, 0.04);\r\n  }\r\n}\r\n\r\n.tradegpt-widget-recent-prompts__section__item__title {\r\n  color: rgba(0, 0, 0, 0.87);\r\n  text-overflow: ellipsis;\r\n  font-family: inherit;\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 171%;\r\n  letter-spacing: 0.17px;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n}\r\n\r\n.sidebar-carrot {\r\n  position: absolute;\r\n  z-index: 40;\r\n  display: block;\r\n  left: 0;\r\n  top: 50%;\r\n  opacity: .4;\r\n  transform: translateX(260px) translateY(-50%) rotate(0deg) translateZ(0);\r\n  cursor: pointer;\r\n}\r\n\r\n.tgpt-sidebar-active {\r\n  background-color: #e5e5e5;\r\n}\r\n\r\n.sidebar-carrot-inner {\r\n  display: flex;\r\n  height: 88px;\r\n  width: 2rem;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.sidebar-carrot-inner-content {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  width: 1.5rem;\r\n  height: 1.5rem;\r\n}\r\n\r\n.carrot-translator {\r\n  height: .75rem;\r\n  width: .25rem;\r\n  border-radius: 99999px;\r\n  background-color: #000;\r\n}\r\n\r\n.translator-a,\r\n.translator-b {\r\n  transition: transform .45s ease;\r\n}\r\n\r\n.sidebar-carrot .translator-a {\r\n  transform: translateY(.15rem) rotate(0deg) translateZ(0);\r\n}\r\n\r\n.sidebar-carrot .translator-b {\r\n  transform: translateY(-.15rem) rotate(0deg) translateZ(0);\r\n}\r\n\r\n.sidebar-carrot:hover .translator-a {\r\n  transform: translateY(.15rem) rotate(15deg) translateZ(0);\r\n}\r\n\r\n.sidebar-carrot:hover .translator-b {\r\n  transform: translateY(-.15rem) rotate(-15deg) translateZ(0);\r\n}\r\n\r\n.tradegpt-widget__sidebar_closed {\r\n  margin-left: -250px;\r\n}\r\n\r\n.sidebar-carrot.closed:hover .translator-a {\r\n  transform: translateY(.15rem) rotate(-15deg) translateZ(0);\r\n}\r\n\r\n.sidebar-carrot.closed:hover .translator-b {\r\n  transform: translateY(-.15rem) rotate(15deg) translateZ(0);\r\n}\r\n\r\n.display-hidden {\r\n  display: none;\r\n}\r\n\r\n.display-flex {\r\n  display: flex;\r\n}\r\n\r\n.tradegpt-widget-full-width {\r\n  width: 100% !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
